import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";

const toggleSx = {
    flexShrink: 0,
    "& .MuiToggleButtonGroup-grouped": {
        margin: 0,
    },
    "& .MuiToggleButton-root": {
        color: "var(--text-muted)",
        borderColor: "var(--border-default)",
        fontSize: "0.72rem",
        fontWeight: 600,
        textTransform: "none",
        padding: "4px 10px",
        gap: "4px",
        minHeight: 32,
        lineHeight: 1.2,
        "& .MuiSvgIcon-root": {
            fontSize: "1rem",
        },
        "&.Mui-selected": {
            color: "var(--text-primary)",
            backgroundColor: "rgba(126, 168, 98, 0.18)",
            borderColor: "var(--brand-strong)",
            "&:hover": {
                backgroundColor: "rgba(126, 168, 98, 0.24)",
            },
        },
    },
};

/**
 * @param {object} props
 * @param {"grid"|"list"} props.value
 * @param {(mode: "grid"|"list") => void} props.onChange
 * @param {string} [props.ariaLabel] - accessible name for the control group
 */
function GridListViewToggle({ value, onChange, ariaLabel = "Layout" }) {
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            size="small"
            onChange={(_, next) => {
                if (next) onChange(next);
            }}
            aria-label={ariaLabel}
            sx={toggleSx}
        >
            <ToggleButton value="grid" aria-label="Grid view">
                <GridViewRoundedIcon fontSize="inherit" />
                Grid
            </ToggleButton>
            <ToggleButton value="list" aria-label="List view">
                <ViewListRoundedIcon fontSize="inherit" />
                List
            </ToggleButton>
        </ToggleButtonGroup>
    );
}

export default GridListViewToggle;
